// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7df5d3b","239":"a3065d39","453":"6ce0293a","667":"e6602e1c"}[chunkId] + ".chunk.js";
};